/* TS Reel Capacity — chart sort / search for sections/ts-reel-capacity.liquid.
   Initialises every instance on the page, and any section re-rendered by the
   theme editor. The row data is the JSON script tag keyed with the same
   section id as the section element. */
const SELECTOR = '[data-ts-rcap]';

function init(root) {
  var src = document.querySelector('[data-rcap-data="' + root.getAttribute('data-ts-rcap') + '"]');
  if (!src) return;
  var data = JSON.parse(src.textContent);
  var order = { '4lb': 4, '6lb': 6, '8lb': 8, '12lb': 12, '15lb': 15, '16lb': 16, '20lb': 20, '30lb': 30, '40lb': 40, '50lb': 50, '60lb': 60, '80lb': 80, '100lb': 100, '40lb Hollow': 140, '60lb Hollow': 160, '80lb Hollow': 180, '100lb Hollow': 200, '130lb Hollow': 230 };
  data.sort(function (a, b) { return a.b.localeCompare(b.b) || a.r.localeCompare(b.r) || (order[a.c] || 999) - (order[b.c] || 999) });
  var body = root.querySelector('[data-rc-body]'),
    count = root.querySelector('.rc-count'),
    none = root.querySelector('.rc-none'),
    inp = root.querySelector('.rc-inp');
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c] }) }
  function render(q) {
    q = (q || '').trim().toLowerCase();
    var rows = data.filter(function (d) { return !q || ((d.b + ' ' + d.r + ' ' + d.c).toLowerCase().indexOf(q) > -1) });
    var html = '', i;
    for (i = 0; i < rows.length; i++) { var d = rows[i]; html += '<tr><td>' + esc(d.b) + '</td><td>' + esc(d.r) + '</td><td class="rc-cls">' + esc(d.c) + '</td><td class="rc-cap">' + d.m + 'm</td></tr>' }
    body.innerHTML = html;
    none.hidden = rows.length > 0;
    count.textContent = rows.length + ' of ' + data.length + ' entries' + (q ? ' matching “' + q + '”' : '');
  }
  var t;
  inp.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { render(inp.value) }, 120) });
  render('');
}

function initAll(scope) {
  (scope || document).querySelectorAll(SELECTOR).forEach(function (r) {
    if (r.dataset.rcapReady) return;
    r.dataset.rcapReady = '1';
    init(r);
  });
}

initAll();
document.addEventListener('shopify:section:load', function (e) {
  initAll(e.target);
});
